export const convertAdminTypeToString = (value: any) => {
  switch (value) {
    case 'SUPER_ADMIN':
      return 'Super admin';
    case 'ADMIN':
        return 'Admin'
    default:
      return '';
  }
};
